import React from "react";

export default function Mission2(props) {
  return (
    <>
      {props.track === "AI Engineer" ? (
        <>
          <h2 className="mission-2">
            Mission 2: Publish your source code & Deploy
          </h2>
          <h3 id="description-1">Description</h3>
          <p>
            Publish your source code in a <strong>github repository</strong>. It
            should both contain the code how you made it and the visualisation
            itself (as an image). We’d like to see the steps how you arrived at
            the solution, so please make sure to commit every step you did and
            not just the final application in 1 or 2 commits. If you are not
            familiar with github, follow the instructions{" "}
            <a href="https://docs.github.com/en/github/getting-started-with-github/create-a-repo">
              here
            </a>
            .
          </p>
          <p>
            The next step is to <strong> deploy </strong>the model. You would
            need to create an endpoint that returns your predictions. Make sure
            that your endpoint accepts a POST request with a JSON body like
            this:
            <pre>
              {" "}
              <code className="code json">
                {"{"}
                <br />
                <span className="code-attr">"year"</span>:
                <span className="code-string">2020</span>,
                <br />
                <span className="code-attr">"month"</span>:
                <span className="code-string">10</span>
                <br />
                {"}"}
              </code>
            </pre>{" "}
            <br />
            And it should return your applications prediction in the following
            format:
            <pre>
              {" "}
              <code className="code json">
                {"{"}
                <br />
                <span className="code-attr">"prediction"</span>:
                <span className="code-string">value</span>
                <br />
                {"}"}
              </code>
            </pre>{" "}
            <br />
            The model can be deployed to a cloud service. You can use (aws,
            google cloud, heroku or whatever you prefer, they usually all
            provide a freetier)
          </p>
        </>
      ) : (
        <>
          <h2 className="mission-2">
            Mission 2: Publish your source code & Deploy
          </h2>
          <h3 id="description-1">Description</h3>
          <p>
            Publish your source code in a <strong>github repository</strong>.
            We’d like to see the steps how you arrived at the solution, so
            please make sure to commit every step you did and not just the final
            application in 1 or 2 commits. If you are not familiar with github,
            follow the instructions{" "}
            <a href="https://docs.github.com/en/github/getting-started-with-github/create-a-repo">
              here
            </a>
            .
          </p>
          <p>
            The next step is to <strong> deploy </strong>the app. The app can be
            deployed to a cloud service. You can use (aws, google cloud, heroku
            or whatever you prefer, they usually all provide a freetier)
          </p>
        </>
      )}
    </>
  );
}
